module.exports = __webpack_public_path__ + "4ce18f2d6fd5a57b48607ae76b1d76c9.MP3";